import { createFileRoute } from "@tanstack/react-router";

import GatewayEndpointsPage from "@/features/dashboard/pages/gateway-endpoints";

export const Route = createFileRoute("/(app)/ops/kra-connection/endpoints")({
  component: () => <GatewayEndpointsPage />,
});
